var map = {
	"./CanvasClear": 132,
	"./CanvasClear.js": 132,
	"./CanvasMove": 133,
	"./CanvasMove.js": 133,
	"./CommandAbstract": 66,
	"./CommandAbstract.js": 66,
	"./ComponentDelete": 134,
	"./ComponentDelete.js": 134,
	"./ComponentDrag": 135,
	"./ComponentDrag.js": 135,
	"./ComponentEnter": 136,
	"./ComponentEnter.js": 136,
	"./ComponentExit": 137,
	"./ComponentExit.js": 137,
	"./ComponentNext": 138,
	"./ComponentNext.js": 138,
	"./ComponentPrev": 139,
	"./ComponentPrev.js": 139,
	"./ComponentStyleClear": 140,
	"./ComponentStyleClear.js": 140,
	"./CopyComponent": 141,
	"./CopyComponent.js": 141,
	"./DeleteComponent": 142,
	"./DeleteComponent.js": 142,
	"./ExportTemplate": 143,
	"./ExportTemplate.js": 143,
	"./Fullscreen": 144,
	"./Fullscreen.js": 144,
	"./MoveComponent": 145,
	"./MoveComponent.js": 145,
	"./OpenAssets": 146,
	"./OpenAssets.js": 146,
	"./OpenBlocks": 147,
	"./OpenBlocks.js": 147,
	"./OpenLayers": 148,
	"./OpenLayers.js": 148,
	"./OpenStyleManager": 149,
	"./OpenStyleManager.js": 149,
	"./OpenTraitManager": 150,
	"./OpenTraitManager.js": 150,
	"./PasteComponent": 151,
	"./PasteComponent.js": 151,
	"./Preview": 152,
	"./Preview.js": 152,
	"./Resize": 153,
	"./Resize.js": 153,
	"./SelectComponent": 49,
	"./SelectComponent.js": 49,
	"./SelectPosition": 76,
	"./SelectPosition.js": 76,
	"./ShowOffset": 154,
	"./ShowOffset.js": 154,
	"./SwitchVisibility": 155,
	"./SwitchVisibility.js": 155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 245;